// To-do - a persisted checklist with filters.
import { el, btn, input, wrap, saveFlag } from "./ui.js";
import { readJSON, writeJSON } from "../shared/store.js";
import { bump } from "../shared/activity.js";

const KEY = "revault:todo";
const load = () => { const v = readJSON(KEY, []); return Array.isArray(v) ? v : []; };

export function todo(root) {
	const s = wrap(root); s.classList.add("rv-todo");
	let items = load();
	let filter = "all";
	const flag = saveFlag();
	const save = () => flag.set(writeJSON(KEY, items));

	const form = el("form", "rv-todo-form");
	const box = input("text", { placeholder: "Add a task and press Enter…" });
	box.classList.add("rv-todo-input");
	box.setAttribute("aria-label", "New task");
	form.appendChild(box);
	form.addEventListener("submit", (e) => { e.preventDefault(); const t = box.value.trim(); if (!t) return; items.unshift({ id: Date.now(), text: t, done: false }); box.value = ""; save(); renderList(); });

	const listEl = el("ul", "rv-todo-list");
	const foot = el("div", "rv-todo-foot");

	function renderList() {
		listEl.textContent = "";
		const shown = items.filter((it) => filter === "all" || (filter === "active" ? !it.done : it.done));
		if (!shown.length) listEl.appendChild(el("li", "rv-tnote", "Nothing here."));
		shown.forEach((it) => {
			const li = el("li", "rv-todo-item" + (it.done ? " done" : ""));
			const cb = input("checkbox"); cb.checked = it.done;
			cb.setAttribute("aria-label", it.text);
			cb.addEventListener("change", () => { const was = it.done; it.done = cb.checked; save(); if (!was && it.done) bump("td"); renderList(); });
			const span = el("span", "rv-todo-text", it.text);
			const del = btn("✕", () => { items = items.filter((x) => x.id !== it.id); save(); renderList(); }, "rv-todo-del");
			del.setAttribute("aria-label", "Delete " + it.text);
			li.append(cb, span, del);
			listEl.appendChild(li);
		});
		const left = items.filter((it) => !it.done).length;
		foot.textContent = "";
		const countEl = el("span", "rv-todo-count", left + " left");
		countEl.setAttribute("role", "status");
		foot.append(countEl);
		const filters = el("div", "rv-todo-filters");
		filters.setAttribute("role", "group");
		filters.setAttribute("aria-label", "Show");
		[["all", "All"], ["active", "Active"], ["done", "Done"]].forEach(([f, label]) => {
			const b = btn(label, () => { filter = f; renderList(); const again = foot.querySelector(".rv-chip.active"); if (again) again.focus(); }, "rv-chip" + (filter === f ? " active" : ""));
			filters.appendChild(b);
		});
		foot.append(filters, btn("Clear done", () => { items = items.filter((it) => !it.done); save(); renderList(); }, "rv-tbtn"));
	}

	s.append(form, flag, listEl, foot);
	renderList();
	box.focus();
}
